import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AllSections from "../components/allsections"
import { TransitionState } from "gatsby-plugin-transition-link"
import { motion } from "framer-motion"


const Page = ({ data: { post } }) => {
  
  const sections = post.layoutBuilder.layoutBuilder || []

  if (post.title == "Contact") {
    typeof window !== "undefined" &&
      window.gtag("config", "AW-307981087/bks8CMbW9PUCEJ_W7ZIB", {
        phone_conversion_number: "01614343881",
      })
  }



  return (
    <Layout hideFooter={(post.title == "Contact (2022)" || post.title == "Contact (2023)" || post.title == "Get a Quote") ? true : false}>
  
      <SEO
        title={post.seo?.title}
        description={post.seo?.metaDesc}
        metaRobotsNofollow={post.seo?.metaRobotsNofollow}
        metaRobotsNoindex={post.seo?.metaRobotsNoindex}
        canonical={post.seo?.canonical ? post.seo.canonical : post.uri}
      />

      <TransitionState>
        {({ transitionStatus, entry, exit }) => {
          return (
            <motion.div
              className="main"
              initial={false}
              animate={
                transitionStatus === "exiting" ? { opacity: 0 } : { opacity: 1 }
              }
              transition={
                transitionStatus === "exiting"
                  ? { duration: 0.2 }
                  : { duration: 0.6, delay: 0.4 }
              }
            >
              {sections.length ? (
                sections.map((section, index) => {
                  return (
                  <AllSections key={index} sectionData={section} />
                  )
                })
              ) : (
                <div className="w-screen h-screen bg-black"></div>
              )}
            </motion.div>
          )
        }}
      </TransitionState>
    </Layout>
  )
}

export default Page

export const pageQuery = graphql`
  query PageById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current post by id
    post: wpPage(id: { eq: $id }) {
      id
      title
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
      }
      layoutBuilder {
        layoutBuilder {
          ... on WpPage_Layoutbuilder_LayoutBuilder_Hero {
            title
            video
            vimeoUrl
            fieldGroupName
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_LogoCarousel {
            fieldGroupName
            title
            logos {
                
                altText
              localFile {
                childImageSharp {
                    gatsbyImageData(
                        height: 200
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_LogoStrip {
            fieldGroupName
            title
            logos {
              altText
              caption
              localFile {
                childImageSharp {
                  fluid(maxHeight: 200) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_ContactDetails {
            fieldGroupName
            title
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_ContactForm {
            fieldGroupName
            title
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_ContactForm2022 {
            fieldGroupName
            image {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            image2 {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_VimeoEmbed {
            fieldGroupName
            label
            title
            vimeoId
            textAlign
            cloudinaryPosterAnim
            reverseLabelOrder
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_Marquee {
            fieldGroupName
            text
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_ContentBlock {
            fieldGroupName
            content
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_ImageBlock {
            fieldGroupName
            image {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1200, quality: 80, webpQuality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_HoverBulletpoints {
            fieldGroupName
            title
            alignment
            bullets {
              title
              hoverType
              video
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1024) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_TeamCarousel {
            fieldGroupName
            slides {
              title
              name
              description
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1024) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_Columns {
            fieldGroupName
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
            label
            title
            pullUpFirstSection
            centerIntro
            rows {
              bottomSpacing
              columnLayout
              verticalColumnLayout
              topSpacing
              reverseColumnOrder
              fullWidth
              columns {
                colType
                fieldGroupName
                text
                width
                pushDown
                reduceMobileWidth
                image {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 1024
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                      )
                    }
                  }
                }
                anim
                buttons {
                  buttonType
                  buttonColour
                  button {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_IntroPanel {
            fieldGroupName
            label
            title
            alternateLayout
            sectionOptions {
              bgColour
              textColour
              bottomSpacing
              topSpacing
            }
            buttons {
              buttonColour
              buttonType
              button {
                target
                title
                url
              }
            }
            topAsset {
              type
              video
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1024) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            rightAsset {
              type
              video
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1024) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            bottomAsset {
              type
              video
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1024) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
          ... on WpPage_Layoutbuilder_LayoutBuilder_Services {
            fieldGroupName
            allServices {
              ... on WpService {
                id
                title
                uri
                featuredImage {
                  node {
                    altText
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 1024) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
